<div class="screen-locker" visanaLibFocusTrap (click)="cancelWhenClickOutsidePopup($event)" *ngIf="isOpen">
  <div [ngClass]="['popup', popupStyle]">
    <div class="container">
      <div *ngIf="hasHeader" class="header">
        <h2 class="headline-3">{{ title }}</h2>
        <visana-lib-button
          (click)="closed.emit()"
          variant="primary"
          aria-label="close"
          iconSize="16"
          buttonSize="small"
          iconName="cross"
          iconPosition="right"
          data-analytics="popup_close"
          >{{ 'CONTACT_OVERLAY.CLOSE' | translate }}
        </visana-lib-button>
      </div>
      <div *ngIf="!hasHeader" class="offset-button">
        <visana-lib-button
          (click)="closed.emit()"
          variant="primary"
          aria-label="close"
          iconSize="16"
          buttonSize="small"
          iconName="cross"
          iconPosition="right"
          data-analytics="popup_close"
          >{{ 'CONTACT_OVERLAY.CLOSE' | translate }}
        </visana-lib-button>
      </div>
      <div>
        <ng-content select="content"></ng-content>
      </div>
      <div class="footer">
        <ng-content select="footer"></ng-content>
      </div>
    </div>
  </div>
  <visana-lib-scroll-lock></visana-lib-scroll-lock>
</div>
